import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import MusicPlayer from './../player/MusicPlayer';
import BackgroundMusicPlayer from '../player/BackgroundMusicPlayer';
import NavBar from '../navigation/NavBar';
import SideBar from '../navigation/SideBar';
import Container from '../views/Container';
import navigationStore from '../../stores/navigation';
import musicStore from '../../stores/music';

function Landscape() {
  const isSideBarOn = navigationStore((state) => state.isSideBarOn);
  const isMusicRetrieved = musicStore((state) => state.isRetrieved);
  const drawerWidth = isSideBarOn ? 250 : 0;

  const videoJsOptions = {
    autoplay: false,
    controls: false,
    poster:null,
    responsive: false,
    fluid: false,
    width: "100%",
    height: "100%",
    sources: [{
      type: 'application/x-mpegURL'
    }]
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <NavBar
        drawerWidth={drawerWidth}
      >
      </NavBar>
      {isSideBarOn &&
        (
          <SideBar drawerWidth={drawerWidth} />
        )
      }
      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3, marginLeft:0 }}
      >
        <Container />
        <BackgroundMusicPlayer
          options={videoJsOptions}
        />
        {/* <MusicPlayer
          options={videoJsOptions}
        /> */}
      </Box>
    </Box>
  );
}

export default Landscape;
